export default "__VITE_PUBLIC_ASSET__921b2491__"